import { CustomMessageActions } from 'stream-chat-react';

export const customMessageActions: CustomMessageActions = {
  Copy: (message) => {
    if (message.text) {
      navigator.clipboard.writeText(message.text);
    }
  },
};
